import { createRoot } from "react-dom/client";
import App from "./app/App.tsx";
import * as Sentry from "@sentry/react";
import { CONFIG } from "./config/index.ts";
import "./locales/i18n.ts";

// INIT ZOD
import "./infra/zodInit.ts";

// mixpanel init
import "./infra/analytics/analytics.ts";

console.log("CONFIG", CONFIG);

Sentry.init({
	dsn: "https://397283d231c95602117a9c273d0ff44c@o4507773250764800.ingest.de.sentry.io/4509436038873168",
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: true,
	environment: import.meta.env.MODE,
	replaysSessionSampleRate: CONFIG.IS_DEV ? 0.1 : 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
			replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
			integrations: [
				Sentry.replayIntegration({
					maskAllInputs: false,
					maskAllText: false,
					blockAllMedia: false,
				}),
			],
});

// Render the app - i18n loading is handled inside App component
createRoot(document.getElementById("root")!).render(<App />);
